import { LoginPage as DoorwayLoginPage } from "@jasper/doorway";
import Cookies from "js-cookie";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import packageJson from "../../../package.json";
import { api } from "../../services/api/api";
import { useAuthContext } from "../../shared/contexts/AuthContext";
import { LoginCredentials } from "@jasper/client-models";

export const LoginPage: FC = () => {
  const navigate = useNavigate();
  const { logIn } = useAuthContext();

  const onLogin = async (data: LoginCredentials) => {
    const res = await api.post("auth/login", {
      email: data.email.trim(),
      password: data.password,
      version: packageJson.version,
    });
    if (res.status !== 200 || res.data === "undefined") {
      throw new Error();
    }
    Cookies.remove("Authentication");
    Cookies.remove("Refresh");
    logIn(res.data);
    navigate("/");
  };

  return <DoorwayLoginPage onLogin={onLogin} />;
};
